module.exports = __webpack_public_path__ + "img/PhpStorm_icon.0d0645ec.png";